import { render, staticRenderFns } from "./smartClassroom.vue?vue&type=template&id=964a32c4&scoped=true&"
import script from "./smartClassroom.vue?vue&type=script&lang=js&"
export * from "./smartClassroom.vue?vue&type=script&lang=js&"
import style0 from "./smartClassroom.vue?vue&type=style&index=0&id=964a32c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a32c4",
  null
  
)

export default component.exports